import angular from "angular";
import OTEService from "./OTEService";
import OTEPOFCtrl from "./OTEPOFCtrl";

export default angular
.module("sonas.ote", [])
.config(function routes($stateProvider){
  $stateProvider
  .state("ote-pof", {
    url: "/pof",
    template: require("./ote.pof.html"),
    controller: OTEPOFCtrl,
    controllerAs: "ctrl",
    resolve: OTEPOFCtrl.resolve
  })
})
.service("OTEService", OTEService)
.name;



// WEBPACK FOOTER //
// ./src/OTE/index.js